// Shared bits of a panel's frame: the corner close button, and the open / close
// bookkeeping every panel does (the Esc stack and the sounds).

import type { AudioService } from "../audio/AudioService";
import { pushModal, removeModal } from "./modalStack";

const CLOSE_SVG =
  '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" fill="none"/></svg>';

/** The × in a panel's top-right corner. */
export function panelCloseButton(onClose: () => void): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "panel-close";
  btn.setAttribute("aria-label", "Close");
  btn.innerHTML = CLOSE_SVG;
  btn.addEventListener("click", () => onClose());
  return btn;
}

/** A panel has just been put on the page: Esc can close it, and it sounds. */
export function panelOpened(overlay: HTMLElement, close: () => void, audio: AudioService | null): void {
  pushModal(overlay, close);
  audio?.play("ui.open");
}

/** A panel is leaving the page. */
export function panelClosed(overlay: HTMLElement, audio: AudioService | null): void {
  removeModal(overlay);
  audio?.play("ui.close");
}
